The date and time when the position was created in the partner's system.
